'use strict'

require 'grpn-ls-polyfills/lib/polyfills-prod'
$ = window.$ = window.jQuery = require 'jquery'
require('../../../src/frontend/core/jquery.safe-ready') $
require('../../../src/frontend/core/jquery.addons') $
require('../../../src/frontend/old/groupon_modules/placeholder_field') $
require('../../../src/frontend/old/common/core_libraries')
